import { graphql } from '../gql';
import { useQuery } from '@apollo/client';

export const GET_CLAIM_DETAILS = graphql(`
  query getClaimDetails($uuid: String) {
    submissions(filters: { nestedFilters: { claimUuid: $uuid } }) {
      edges {
        cursor
        node {
          uuid
          referenceId
          aggregateLimit
          policyRetention
          brokerCommission
          type
          insuredEntity {
            cursor
            node {
              uuid
              persons {
                edges {
                  cursor
                  node {
                    uuid
                    firstName
                    lastName
                    agent
                    source
                    primary
                    primaryContact
                    contacts {
                      edges {
                        cursor
                        node {
                          uuid
                          type
                          value
                          source
                          primary
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          brokerEntity {
            cursor
            node {
              uuid
              addresses(filters: { source: PRIMARY, type: CORPORATE }) {
                edges {
                  cursor
                  node {
                    uuid
                    street1
                    street2
                    city
                    type
                    postalCode
                    source
                    regions {
                      edges {
                        cursor
                        node {
                          uuid
                          name
                          iso2Code
                        }
                      }
                    }
                    countries {
                      edges {
                        cursor
                        node {
                          uuid
                          name
                          iso2Code
                          iso3Code
                        }
                      }
                    }
                    primary
                  }
                }
              }
              aliases(filters: { groupSources: true }) {
                edges {
                  cursor
                  node {
                    uuid
                    name
                    sources
                    type
                    primary
                  }
                }
              }
              persons {
                edges {
                  cursor
                  node {
                    uuid
                    firstName
                    lastName
                    agent
                    source
                    primary
                    primaryContact
                    contacts {
                      edges {
                        cursor
                        node {
                          uuid
                          type
                          value
                          source
                          primary
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          quotes(filters: { status: BOUND }) {
            edges {
              node {
                limit
                retention
                policies {
                  edges {
                    node {
                      referenceId
                      type
                      startDate
                      endDate
                      boundPremium
                      grossPremium
                      netPremium
                    }
                  }
                }
              }
            }
          }
          program {
            node {
              uuid
              name
            }
          }
          partner {
            node {
              uuid
              aliases(filters: { source: PRIMARY, type: LEGAL_NAME }) {
                edges {
                  node {
                    name
                  }
                }
              }
            }
          }
          product {
            node {
              uuid
              name
            }
          }
          capacityProviderEntity {
            node {
              uuid
              aliases(filters: { source: PRIMARY, type: LEGAL_NAME }) {
                edges {
                  node {
                    name
                  }
                }
              }
            }
          }
          capacityProviders(sort: { order: "ASC", key: "order" }) {
            edges {
              node {
                uuid
                quote {
                  quotaShare
                }

                aliases(filters: { source: PRIMARY, type: LEGAL_NAME }) {
                  edges {
                    node {
                      name
                    }
                  }
                }
              }
            }
          }
          persons {
            edges {
              cursor
              node {
                uuid
                firstName
                lastName
                agent
                title
                type
                source
                personType {
                  uuid
                  type
                  title
                }
                primary
                contacts {
                  edges {
                    cursor
                    node {
                      uuid
                      type
                      value
                      source
                      primary
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);

export interface IUseClaimDetailQueryArg {
  claimUuid?: string;
}
export function useClaimDetailsQuery({ claimUuid }: IUseClaimDetailQueryArg) {
  const { loading, data, error } = useQuery(GET_CLAIM_DETAILS, {
    variables: {
      uuid: claimUuid,
    },
  });

  return {
    loading,
    error,
    data,
  };
}
